import signUpComponent from './sign-up.component';

const signUpModule = angular.module('signUp', [
])
  .component('signUp', signUpComponent)
  .name;

export default signUpModule;
